
import styles from './ReviewSlide.module.scss';
import { Image } from '../Image/Image';
import cn from 'classnames';

export const ReviewSlide = ({slide,type,rating})=>{
  const {review,name,image } = slide;
  return(
    <>
    {image && 
    <Image src={image} className={styles.slideImage} />
    }
    <div className={cn(
      styles.slide,
      image && styles.slideWithImage
    )}>
      <Image src="/assets/Quiz/icons/quote.png" className={styles.slideQuote} />
      <p className={styles.slideReview} dangerouslySetInnerHTML={{ __html: review }} />
      <div className={styles['slide-footer']}>
        {
          type ==="onboadring" || type === 'paywall'? (
            <>
            <div className={styles.stars}>
              <span className={styles.rating}>5.0</span>
              {Array.from({ length: 5 }).map((_, index) => (
                <Image
                  key={index}
                  src="/assets/Quiz/icons/star.png"
                  className={styles.star}
                />
              ))}
            </div>
            <p className={styles.slideName}>{name}</p>
            </>
          ) : (
            <>
            <p className={styles.slideName}>{name}</p>
            <div className={styles.stars}>
              {rating && <span className={styles.rating}>{rating}</span>}
              {Array.from({ length: 5 }).map((_, index) => (
                <Image
                  key={index}
                  src="/assets/Quiz/icons/star.png"
                  className={styles.star}
                />
              ))}
            </div>
            </>
          )
        }
        
      </div>
    </div>
    </>

  )
}